import React, { Component } from "react";
import add from "../Images/add.png";
import pharmeasy from "../Images/pharmeasy.png";
import plural from "../Images/plural.png";
import soundgen from "../Images/soundgen.png";
import soundsapp from "../Images/sounds.png";
import superFam from "../Images/superFam.png";
class ContainerRight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slider: [
        {
          id: 1,
          image: superFam,
          alt: "images",
          git: "https://github.com/SumanJK/superFam",
          live: "https://superfam-by-sumangiri.netlify.app/",
        },
        {
          id: 2,
          image: pharmeasy,
          alt: "images",
          git: "https://github.com/SumanJK/Pharmeasy_clone",
          live: "https://pharmeasybysumangiri.netlify.app/",
        },
        {
          id: 4,
          image: plural,
          alt: "images",
          git: "https://github.com/SumanJK/pluralsight_clone-web15",
          live: "https://pluralsight-clone-1.netlify.app/",
        },
        {
          id: 6,
          image: soundgen,
          alt: "soundgen",
          live: "https://soundgen.io",
        },
        {
          id: 7,
          image: add,
          alt: "add",
          live: "https://add.app",
        },
        {
          id: 8,
          image: soundsapp,
          alt: "soundsapp",
          live: "https://sounds.add.app",
        },
      ],
    };
  }
  render() {
    return (
      <div
        className="col-right animate-element wow delay5 fadeInUp"
        data-wow-delay="0.5s"
      >
        <div
          className="flat-spacer"
          data-desktop="4"
          data-mobile="70"
          data-smobile="70"
        ></div>
        <div className="slider-drop-apps custom-dot dot-t2 dot-s2 number-pages none-nav-default mg-dots-s2">
          <div
            className="flat-carousel-box data-effect clearfix"
            data-gap="0"
            data-column="1"
            data-column2="1"
            data-column3="1"
            data-column4="1"
            data-column5="1"
            data-dots="true"
            data-auto="false"
            data-nav="false"
            data-loop="true"
          >
            <div className="owl-carousel">
              {this.state.slider.map((data) => (
                <div className="featured-post" key={data.id}>
                  <img class="projectImg" src={data.image} alt={data.alt} />
                  <div class="buttonDiv">
                    {data?.git && (
                      <a target="_blank" rel="noreferrer" href={data.git}>
                        <button class="sourceBtn">View source</button>
                      </a>
                    )}
                    <a target="_blank" rel="noreferrer" href={data.live}>
                      <button class="liveBtn">Live Demo</button>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContainerRight;
